var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.352,
    height: 54.184,
    viewBox: "0 0 55.352 54.184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_17399",
    x: 0,
    y: 0,
    width: 55.352,
    height: 54.184,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29965",
    "data-name": "Group 29965",
    transform: "translate(-1032.395 -182.693)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1032.39, 182.69)",
    filter: "url(#Path_17399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_17399-2",
    "data-name": "Path 17399",
    transform: "translate(9 6)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.092,0h1.167a18.092,18.092,0,0,1,0,36.184H18.092A18.092,18.092,0,0,1,18.092,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.09216117858887 1.000003814697266 C 13.52668190002441 1.000003814697266 9.234460830688477 2.77789306640625 6.006181716918945 6.006183624267578 C 2.77789306640625 9.234462738037109 1 13.52668380737305 1 18.0921630859375 C 1 22.65764236450195 2.77789306640625 26.94986343383789 6.006181716918945 30.17814254760742 C 9.234460830688477 33.40643310546875 13.52668190002441 35.18432235717773 18.09216117858887 35.18432235717773 L 19.25940132141113 35.18432235717773 C 23.82488250732422 35.18432235717773 28.11710166931152 33.40643310546875 31.34538078308105 30.17814254760742 C 34.57366180419922 26.94986343383789 36.3515625 22.65764236450195 36.3515625 18.0921630859375 C 36.3515625 13.52668380737305 34.57366180419922 9.234462738037109 31.34538078308105 6.006183624267578 C 28.11710166931152 2.77789306640625 23.82488250732422 1.000003814697266 19.25940132141113 1.000003814697266 L 18.09216117858887 1.000003814697266 M 18.09216117858887 3.814697265625e-06 L 19.25940132141113 3.814697265625e-06 C 29.25142097473145 3.814697265625e-06 37.3515625 8.100133895874023 37.3515625 18.0921630859375 C 37.3515625 28.08419418334961 29.25142097473145 36.18432235717773 19.25940132141113 36.18432235717773 L 18.09216117858887 36.18432235717773 C 8.100131988525391 36.18432235717773 0 28.08419418334961 0 18.0921630859375 C 0 8.100133895874023 8.100131988525391 3.814697265625e-06 18.09216117858887 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#EB1700"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17397",
    "data-name": "Path 17397",
    d: "M13.952,13.952A4.976,4.976,0,1,0,8.976,8.976,4.975,4.975,0,0,0,13.952,13.952Zm0,2.488C10.631,16.44,4,18.107,4,21.416V23.9H23.9V21.416C23.9,18.107,17.274,16.44,13.952,16.44Z",
    transform: "translate(1046.118 191.832)",
    fill: "#EB1700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarWhiteIcon);
export default __webpack_public_path__ + "static/media/avatar-white-icon.08f90ed3ca0b938ac7e35ebbc10d4cd8.svg";
export { ForwardRef as ReactComponent };